// extracted by mini-css-extract-plugin
export default {"grid":"WalletStats_grid__T0NMe","stat":"WalletStats_stat__LUtn0","title":"WalletStats_title__yqFXV","value":"WalletStats_value__z0atT"};